import clsx from 'clsx';
import { useDebouncedValue } from 'hooks/useDebouncedValue';

import styles from './Sidebar.module.scss';
import SidebarContentDrillX from './components/SidebarContentDrillX';

type Props = {
  isOpen: boolean;
  onSidebarChanged: () => void;
};

export const useSidebar = ({ isOpen, onSidebarChanged }: Props) => {
  const isOpenDelayed = useDebouncedValue(isOpen, parseInt(styles.transitionDurationInMs));

  // open and close are specific selector names in css to track the sidebar state
  const getStylePerState = (basicStyle: string) =>
    clsx(basicStyle, isOpen ? styles.open : styles.close);

  const getSideBarComponentToRender = () => {
    return <SidebarContentDrillX />;
  };

  return {
    getStylePerState,
    isOpenDelayed,
    getSideBarComponentToRender,
  };
};
